/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Вид для страницы торговой марки "Тундра"
   */
  app.KomandorView = app.View.extend({
    el: '[data-jsview = "komandor"]',
    
    run: function () {
      this.addOwlCarousel();
    },

    addOwlCarousel: function () {
      this.newsCarousel = this.$el.find('.tm-news');
      var owlConfig = {
        dots: false,
        slideBy: 1,
        responsive: {
          0: {
            items: 1,
            nav: true
          },
          420: {
            items: 3,
            nav: true
          },
          1200: {
            items: 4,
            nav: true
          }
        }
      };
      if (this.$('.tm-news-item').length <= 4 && app.isDesktop) {
        owlConfig.nav = false;
      }
      this.newsCarousel.owlCarousel(owlConfig);
    },
  });
})();

}.call(window));